// ┌─────────────────────────────────────────────────────────────────────────┐
// │ BINDING camp → programa.                                                  │
// └─────────────────────────────────────────────────────────────────────────┘
//
// Cada camp de Sherpa (id fix) activa UN programa. Quan el camp apareix a un
// formulari carregat, el seu programa s'executa. El programa fa servir els
// altres camps que necessita NOMÉS si hi són a les dades (degrada amb gràcia).
//
// Aquest mapa és la DADA del binding. La FONT real és Sherpa: `computedStore`
// crida el task `/filetransform/aliasprogram/task` i injecta el binding viu amb
// `setRemoteFieldPrograms()`. Aquest `FIELD_PROGRAMS` estàtic queda com a FALLBACK
// (standalone sense backend, o abans de la primera càrrega).
//
//   · QUIN camp dispara QUIN programa → ve del model (task), no s'edita aquí.
//   · QUÈ FA un programa → el seu `code` al catàleg (BD), carregat i executat en
//     runtime pel motor (core/computed); el component no en codifica res.

// fieldId (id exacte del camp Sherpa) → programId. BUIT a posta: el binding REAL
// ve SEMPRE del model (task Sherpa → setRemoteFieldPrograms, que pisa aquest mapa).
// El component no codifica cap binding camp→programa de client; en standalone sense
// backend (sense programes) simplement no es dispara cap programa.
export const FIELD_PROGRAMS = Object.freeze({});

// Binding viu carregat des de Sherpa (override en memòria, com runtimeConfig).
// null ⇒ s'usa el FIELD_PROGRAMS estàtic.
let REMOTE_FIELD_PROGRAMS = null;

export function setRemoteFieldPrograms(map) {
  REMOTE_FIELD_PROGRAMS = (map && typeof map === 'object') ? map : null;
}

export function clearRemoteFieldPrograms() {
  REMOTE_FIELD_PROGRAMS = null;
}

export function hasRemoteFieldPrograms() {
  return REMOTE_FIELD_PROGRAMS != null;
}

// Construeix el mapa àlies→programId a partir de la resposta del task
// ([{ name, aliases:[…] }]). Usa el NOM del programa (= id del calculador local).
export function buildFieldProgramsFromRemote(programs) {
  const map = {};
  for (const p of programs || []) {
    const programId = p?.name;
    if (!programId) continue;
    for (const alias of (p.aliases || [])) {
      if (alias && !map[alias]) map[alias] = programId;
    }
  }
  return map;
}

function activeFieldPrograms() {
  return REMOTE_FIELD_PROGRAMS || FIELD_PROGRAMS;
}

function getFieldId(field) {
  return field?.id || field?.name || field?.label || '';
}

// Llista (deduplicada, en ordre d'aparició) dels programes a executar segons
// els camps presents al formulari.
export function programsForFields(fields) {
  const binding = activeFieldPrograms();
  const out = [];
  const seen = new Set();
  for (const f of fields || []) {
    const pid = binding[getFieldId(f)];
    if (pid && !seen.has(pid)) {
      seen.add(pid);
      out.push(pid);
    }
  }
  return out;
}

// Cert si el camp dispara el programa indicat.
export function fieldTriggersProgram(field, programId) {
  return activeFieldPrograms()[getFieldId(field)] === programId;
}
